import React, { useContext, useEffect } from "react"
import { useState } from "react"
import HorizontalOptionBar from "../components/HorizontalOptionBar"
import styled from "styled-components"
import {useNavigate} from 'react-router-dom'
import { useLocation } from "react-router-dom"
import { BsCalendar4Event, BsLayoutTextWindow } from "react-icons/bs"
import { VscNotebook } from "react-icons/vsc"
import TopSellerCard from "../components/TopSellerCard"
import TopSellerFullView from "../components/TopSellerFullView"
import SimpleFormInput from "../components/SimpleFormInput"
import ArticleCard from "../components/ArticleCard"
import { ThemeContext } from "../context/ThemeContext"
import {
  addDoc,
  collection,
  getDocs,
  query,
  where,
  onSnapshot,
  updateDoc,
  doc,
  deleteDoc
} from "firebase/firestore"
import EditorComp from "../components/EditorComp"
import { db, useAuth } from "../firebase-config"
import { toast, ToastContainer } from "react-toastify"
import PrimaryBtn from "../components/PrimaryBtn"
import {  convertToHTML } from "draft-convert"
import { EditorState} from "draft-js"
import ProductCard from "../components/ProductCard"
import { BlogContext } from "../context/BlogContextProvider"
import { ProductDetailContext } from "../context/ProductDetailsProvider"
import { Oval } from "react-loader-spinner"
import { UserContext } from "../context/UserContextProvider"

const Events = () => {
  const location = useLocation()
  const currentUser = useAuth()
  const [currentEditingArticle, setCurrentEditingArticle] = useState(null)

  const [toggleTab, setToggleTab] = useState(0)
  const [showFullView, setShowFullView] = useState(false)
  const [addAuction, setAddAuction] = useState(false)
  const [addArticle, setAddArticle] = useState('Add Article')
  const [heading, setHeading] = useState("")
  const [mainThumbnail, setMainThumbnail] = useState("")
  const [description, setDescription] = useState('<p>Content Goes here </p>')
  const [editArticleDocId, setEditArticleDocId] = useState(null)
  const [productListArr, setproductListArr] = useState([])
  const [auctionTime, setAuctionTime] = useState("")
  const [auctionProductSelected, setAuctionProductSelected] = useState({})
  const [blogPostArr, setBlogPostArr] = useState([])
  const [auctionAddPrg, setAuctionAddPrg] = useState(false)
  const [auctionListArr, setAuctionListArr] = useState([])
  const [postPrg, setPostPrg] = useState("Post")
  

  const [editorState, setEditorState] = useState(() => EditorState.createEmpty())
  const [convertedContent, setConvertedContent] = useState("")
  const [auctionPrice, setAuctionPrice] = useState(0)
  const topSellerData = [
    {
      fullname: "Leslie Alexander",
    },
    {
      fullname: "ffsie Alexander",
    },
    {
      fullname: "Courtney Henry",
    },
    {
      fullname: "Sounst Henry",
    },
  ]
  const { theme } = useContext(ThemeContext) 
  const [iconColor, setIconColor] = useState(
    theme === "light" ? "#19202A" : "#fff"
  )
  const colorToggle = () => {
    theme === "light" ? setIconColor("#19202A") : setIconColor("#fff")
  }
 const blogContext = useContext(BlogContext) 
 const navigate =  useNavigate()
 const productContext = useContext(ProductDetailContext)
 const {loggedInUser} = useContext(UserContext)




  const postArticle = async () => {
    try {
      setPostPrg('Posting..')
      await addDoc(collection(db, "blog"), {
        heading: heading,
        description: convertedContent,
        mainThumbnail: mainThumbnail,
        // paragraph: subHeadingList,
        userReference: `users/${currentUser?.uid}`,
      })
      toast.success("Posted")
      setPostPrg('Post')
      setHeading("")
      setMainThumbnail(null)
      setDescription("")
    } catch (error) {
      setPostPrg('Post')
      console.log(error)
    }
  }

  const fetchArticle = async () => {
    try {
      const q = query(collection(db, "blog"))
      // const querySnapshot = await getDocs(q)
      onSnapshot(q, querySnapshot => {
        setBlogPostArr(
          querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))
        )
      })
      // setBlogPostArr(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })))
      // console.log(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })))
    } catch (error) {
      console.error(error)
    }
  }

  const fetchProduct = async () => {
    try {
      const q = query(
        collection(db, "products"),
        where("shopId", "==", `shop/${currentUser?.uid}`)
      )
      const querySnapshot = await getDocs(q)
      setproductListArr(querySnapshot.docs.map(doc => ({ ...doc.data(),  id: doc.id  })))
    } catch (error) {
      console.error(error)
    }
  }


  const selectOnChange = e => {
    let value = e.target.value
    console.log(value)
    let tempArr = [...productListArr]
    const filteredProduct = tempArr.filter(
      element => element.id === value
    )
    
    setAuctionProductSelected(filteredProduct[0])
  }
  

  const addNewAuction = async () => {
    let tempAddedAuc = auctionListArr.filter((item) => item?.auctionProductSelected?.id === auctionProductSelected?.id)
    if(tempAddedAuc?.length !== 0) return toast.error('Auction Already Live')
    try {
      setAuctionAddPrg(true)
      await addDoc(collection(db, "auction"), {
        auctionTime: auctionTime,
        auctionPrice: auctionPrice,
        auctionProductSelected,
        sellerId: currentUser?.uid,
      })
      await updateDoc(doc(db, 'products',auctionProductSelected?.id),{
        "productDetails.discountedPrice": auctionPrice
      })
      toast.success("Auction Added")
      setAuctionAddPrg(false)
    } catch (error) {
      setAuctionAddPrg(false)
      console.log(error)
    }
  }

  const deleteAuction = async (id) => {
    console.log(id)
    try {
      await deleteDoc(doc(db, 'auction', id))
      toast.success('Auction Deleted')
    } catch (error) {
      console.log(error)
    }
  }
  const deleteBlog = async (id) => {
    console.log(id)
    try {
      await deleteDoc(doc(db, 'blog', id))
      toast.success('Article Deleted')
    } catch (error) {
      console.log(error)
    }
  }

  const fetchAuction = async () => {
    try {
      const q = query(collection(db, "auction"))
      onSnapshot(q, querySnapshot => {
        setAuctionListArr(querySnapshot.docs.map(doc => ({ ...doc.data(), docId: doc.id })))
      })
      
    } catch (error) {
      console.error(error)
    }
  }


  const handleMainThumbSelect = e => {
    var file = e.target.files[0]
    var reader = new FileReader()
    reader.onloadend = function () {
      setMainThumbnail(reader.result)
    }
    reader.readAsDataURL(file)
  }

  const convertContentToHTML = () => {
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent())
    setConvertedContent(currentContentAsHTML)
  }

  const handleEditorChange = state => {
    setEditorState(state)
    convertContentToHTML()
  }
  
  const handleEditButton = (item) => {
    setAddArticle('Show Article')
    setHeading(item.heading)
    setMainThumbnail(item.mainThumbnail)
    setDescription(item.description)
    setEditArticleDocId(item.id)
    setPostPrg('Update')
  }
  
  const handleViewBtn = (item) => {
    navigate('/blog')
    blogContext.handleArticle(item)
  }


 
  const updateBlog = () => {
    try {
      setPostPrg('Updating..')
      updateDoc(doc(db, 'blog', editArticleDocId),{
        heading: heading,
        description: convertedContent,
        mainThumbnail: mainThumbnail,
        userReference: `users/${currentUser?.uid}`,
      })
      toast.success("Updated")
      setPostPrg('Update')
    } catch (error) { 
      setPostPrg('Update')
      console.log(error)
    }
  }


  useEffect(() => {
    colorToggle()
  }, [theme])
  
  useEffect(() => {
    productContext.handleData({})
    productContext.handleDocId('')
    productContext.handleUser2Id('')
    if(toggleTab === 2 ||  location.hash.replace("%20", " ", "#", "").substring(1) === "Auction"){
      fetchAuction()
      fetchProduct()
    }else if(toggleTab === 3 ||  location.hash.replace("%20", " ", "#", "").substring(1) === "Blog") {
      fetchArticle()
    }else {
      return
    }
  }, [toggleTab,  location.hash.replace("%20", " ", "#", "").substring(1)])
  
  return (
    <>
      <ToastContainer limit={1} position="top-center" />
      <EventsScreenWrap>
        <VerticalTabBar>
          <AdminListArr>
            <Tabbtn
              onClick={() => setToggleTab(1)}
              className={toggleTab === 1 ? "active-tab" : ""}
            >
              <BsCalendar4Event
                style={{ marginRight: "10px" }}
                size={15}
                color={toggleTab === 1 ? "#fff" : iconColor}
              />
              Events
            </Tabbtn>
                <Tabbtn
              onClick={() => setToggleTab(2)}
              className={toggleTab === 2 ? "active-tab" : ""}
            >
              <VscNotebook
                style={{ marginRight: "10px" }}
                size={18}
                color={toggleTab === 2 ? "#fff" : iconColor}
              />
              Auction
            </Tabbtn>
            <Tabbtn
              onClick={() => setToggleTab(3)}
              className={toggleTab === 3 ? "active-tab" : ""}
            >
              <BsLayoutTextWindow
                style={{ marginRight: "10px" }}
                size={15}
                color={toggleTab === 3 ? "#fff" : iconColor}
              />
              Blog
            </Tabbtn>
             
          </AdminListArr>
        </VerticalTabBar>
        {toggleTab === 1 ||
        location.hash.replace("%20", " ", "#", "").substring(1) === "Events" ? (
          <CardContainer>
            {!showFullView ? (
              <>
                <div className="pagetitle_cont">
                  <PageTitle>
                    {location.hash.replace("%20", " ").substring(1)}
                  </PageTitle>
                  {/* <AddEventBtn>Add Event</AddEventBtn> */}
                </div>
                <TopSellerCard
                  title={"Top Seller of the week"}
                  btnLabel={""}
                  noOfGem={10}
                  item={topSellerData}
                  handleOnClick={() => setShowFullView(!showFullView)}
                />
              </>
            ) : (
              <TopSellerFullView
                title={"Top Seller of the week"}
                btnLabel={""}
                btnLabelTwo={""}
                noOfGem={10}
                item={topSellerData}
              />
            )}
          </CardContainer>
        ) : toggleTab === 2 ||
          location.hash.replace("%20", " ").substring(1) === "Auction" ? (
          <AuctionContentWrap>
           {
              loggedInUser.role === 'admin' &&
              <>
           {!addAuction ? (
              <div className="pagetitle_cont">
                <PageTitle>
                  {location.hash.replace("%20", " ").substring(1)}
                </PageTitle>
                {
                  loggedInUser.role === 'admin' &&
                  <AddEventBtn onClick={() => setAddAuction(!addAuction)}>
                  Add Auction
                </AddEventBtn>
                }
              </div>
            ) : (
              <AddEventBtn
                title="test1"
                onClick={() => setAddAuction(!addAuction)}
              >
                Show Auction
              </AddEventBtn>
            )}

           </>
           }
            <AuctionContent>
              {!addAuction ? (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    margin: "0.4rem",
                    flexWrap: 'wrap-reverse'
                  }}
                >
                  {auctionListArr.map((item, index) => {
                    return (
                      <ProductCard
                      key={index}
                      product={item?.auctionProductSelected?.productDetails}
                    linkTo={`/productdetail/:${item?.auctionProductSelected?.id}`}
                    isAuctionCard={true}
                    auctionBy={item.sellerId === currentUser?.uid ? "Me": "Others" }
                    productImage={item.auctionProductSelected?.productPhoto}
                    productPrice={item?.auctionPrice}
                    auctionTime={item.auctionTime}
                    sellerName={""}
                    productName={item.auctionProductSelected?.productDetails?.productName}
                    setWidth={"10rem"}
                    setHeight={"385px"}
                    imgHeight={"234px"}
                    imgWidth={"10rem"}
                    showDeleteBtn={item?.sellerId === currentUser?.uid}
                    handleDeleteBtn={() => deleteAuction(item?.docId)}
                  />
                    )
                  })}
                    
                </div>
              ) : (
                <FormContainer>
                  <SimpleFormInput
                    type="datetime-local"
                    label={"Date & Time *:"}
                    btnLabel={"Topic Name *:"}
                    value={auctionTime}
                    handleOnChange={e => {
                      setAuctionTime(e.target.value)
                    }}
                  />
                  <SimpleFormInput
                    type="type"
                    label={"Auction Price"}
                    btnLabel={""}
                    value={auctionPrice}
                    handleOnChange={e => setAuctionPrice(e.target.value)}
                  />
                  <Select  onChange={selectOnChange}>
                    <option value=""> Select a product</option>
                    {productListArr.map((item, index) => {
                      return (
                        <option
                          key={index}
                          value={item.id}
                          >
                          {item.productDetails?.productName}{" "}
                          {`Price: ${item.productDetails?.discountedPrice}`}
                        </option>
                      )
                    })}
                  </Select>
                  <div>
                    <PrimaryBtn
                      handleBtn={addNewAuction}
                      label={auctionAddPrg ? "Adding..." : "Add"}
                    />
                  </div>
                </FormContainer>
              )}
            </AuctionContent>
          </AuctionContentWrap>
        ) : null}

        {toggleTab === 3 ||
        location.hash.replace("%20", " ").substring(1) === "Blog" ? (
          <BlogWrap>
           {
              loggedInUser.role === 'admin' &&
              <div style={{ width: "100%", display: 'flex', justifyContent: 'flex-end'}}>
              <AddEventBtn onClick={() => setAddArticle(addArticle === 'Show Article' ? 'Add Article' : 'Show Article')}>
                {addArticle}
              </AddEventBtn>
            </div>
           }
            {addArticle === 'Show Article' ? (
              <>
              <p>{currentEditingArticle?.heading}</p>
                <EditorComp
                  inputLabel={"Heading"}
                  heading={heading }
                  handleHeadingChange={e => setHeading(e.target.value)}
                  description={description}
                  handleEditorChange={handleEditorChange}
                  thumbnailSource={mainThumbnail}
                  handleThumbnailSelect={handleMainThumbSelect}
                  editorState={editorState}
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "92%",
                  }}
                >
                  <PrimaryBtn
                    label={postPrg}
                    handleBtn={postPrg === 'Update' ? updateBlog : postArticle}
                  />
                </div>
              </>
            ) : (
              <ArticleCardContainer>
                {
                  blogPostArr.length?
                  blogPostArr.map((item, index) => {
                  return (
                    <ArticleCard
                      key={index}
                      thumbnail={item.mainThumbnail}
                      articleTitle={item.heading}
                      content={item.description}
                      isAdmin={ loggedInUser.role === 'admin'? true: false}
                      handleEditBtn={() => handleEditButton(item)}
                      handleViewBtn={() => handleViewBtn(item)}
                      handleDeleteBtn={() => deleteBlog(item.id)}
                    />
                  )
                })
                : 
                <Oval color={"#fafafa"} secondaryColor={"#dc1d13"} width={"30px"} />
              }
              </ArticleCardContainer>
            )}
          </BlogWrap>
        ) : null}
      </EventsScreenWrap>
    </>
  )
}

export default Events

const EventsScreenWrap = styled.div`
  display: flex;
  @media screen and (max-width: 768px) {
    height: 100vh;
  }
`
const VerticalTabBar = styled.div`
  display: flex;
  position: sticky;
  flex-direction: column;
  align-items: center;
  height: 90vh;
  width: 20%;
  max-width: 20%;
  min-width: 20%;
  background: ${({ theme }) => theme.background};
  /* background: cyan; */
  @media screen and (max-width: 768px) {
    display: none;
  }

  .active-tab {
    background: #dc1d13;
    transition: 500ms;
    cursor: pointer;
    color: #fff;
  }
`
const AdminFormWrap = styled.div`
  display: flex;
  width: 100%;
  background: #fff;

  .infotip_label {
    position: absolute;
    bottom: -5rem;
    right: 1.5rem;
  }
`

const AdminListArr = styled.div`
  display: flex;
  flex-direction: column;
  height: 75vh;
  padding-top: 1.5rem;
  width: 100%;
  overflow-y: auto;

  /* @media screen and (max-width: 768px) {
   flex-direction: row;
  } */
`
const Tabbtn = styled.button`
  color: ${({ theme }) => theme.text};
  text-decoration: none;
  border: none;
  background: none;
  padding: 0.6rem 0rem;
  transition: 500ms;
  cursor: pointer;
  margin-bottom: 2rem;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 29px;
  border-radius: 0px 5px 5px 0px;

  @media screen and (max-width: 768px) {
    color: ${({ theme }) => theme.text};
    font-size: 0.6rem;
  }
`
const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
  height: 90vh;
  overflow-y: auto;
  justify-content: space-around;
  .pagetitle_cont {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
`
const AddEventBtn = styled.button`
  cursor: pointer;
  background: var(--p-red);
  border: none;
  width: 10rem;
  color: #fff;
  float: right;
  height: 3rem;

  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
`
const AuctionContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  align-items: center;

  .pagetitle_cont {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }

  .empty_image {
    width: 206px;
    height: 300px;
  }
`
const AuctionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media screen and (max-width: 768px){
    flex-wrap: wrap;
  }
  .auctionDate {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 1.5rem;
    color: #19202a;
  }

  .auctionTime {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 2rem;
    color: #19202a;
  }
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const BlogWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  height: 80vh;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;

  .pagetitle_cont {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  .empty_image {
    width: 206px;
    height: 300px;
  }
`
const ArticleCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
  height: 90vh;
  overflow-y: auto;
  width: 100%;
  justify-content: space-around;

  :scrollbar-width {
    width: 0;
  }
`

const PageTitle = styled.div`
  padding: 1rem;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text};
`

const Select = styled.select`
  width: 100%;
  background: ${({ theme }) => theme.background};
  padding: 1rem 0.5rem;
  color: ${({ theme }) => theme.text};
`
